export default function statusInit() {
    try {
        if (typeof sessionStorage === 'undefined') return 'unusable';

        const testData = 'session storage test';

        const previousLength = sessionStorage.length;
        sessionStorage.setItem(testData, testData);
        if (
            sessionStorage.length <= previousLength ||
            sessionStorage.getItem(testData) !== testData
        )
            return 'unusable';

        sessionStorage.removeItem(testData);
        if (sessionStorage.length !== previousLength) return 'unusable';

        return 'usable';
    } catch (e) {
        return 'unusable';
    }
}
